<template>
  <div style="background: white">
    <v-simple-table class="special-care-student-table" :height="tableHeight + 'px'" fixed-header>
      <thead>
        <tr>
          <th rowspan="2" style="min-width: 170px; max-width: 170px; left: 0;" class="sroll-left">Mã khách hàng</th>
          <th rowspan="2" style="min-width: 250px; max-width: 250px; left: 170px" class="sroll-left">Tên học viên</th>
          <th rowspan="2" style="min-width: 150px; max-width: 150px; left: 420px" class="sroll-left">Chương trình</th>
          <th rowspan="2" style="min-width: 130px; max-width: 130px; text-align: center">Ngày vào danh sách</th>
          <th v-if="$route.query.tutorSchoolLevel !== SCHOOL_LEVEL.PRIMARY" rowspan="2" style="color: #BB0000; min-width: 130px; max-width: 130px; text-align: center">Hạn chăm sóc bắt buộc</th>
          <th colspan="2" class="merge-header text-center">Chuyên cần</th>
          <th colspan="2" class="merge-header text-center">Học tập</th>
          <th rowspan="2" style="min-width: 150px; max-width: 150px; text-align: center">
            Hủy buổi
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  v-on="on"
                  v-bind="attrs"
                  style="font-size: 20px; margin-left: 6px">
                  mdi-information-outline
                </v-icon>
              </template>
              <div>Vi phạm của học sinh được tính trong tối đa 8 buổi học gần nhất</div>
            </v-tooltip>
          </th>
          <th rowspan="2" style="min-width: 150px; max-width: 150px; text-align: center">
            Đổi giáo viên
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  v-on="on"
                  v-bind="attrs"
                  style="font-size: 20px; margin-left: 6px">
                  mdi-information-outline
                </v-icon>
              </template>
              <div>Vi phạm của học sinh được tính trong tối đa 8 buổi học gần nhất</div>
            </v-tooltip>
          </th>
          <th rowspan="2" style="min-width: 120px; max-width: 120px; text-align: center">Bài kiểm tra sắp tới</th>
          <th rowspan="2" style="min-width: 150px; max-width: 150px">Quản lý lớp</th>
          <th rowspan="2" style="min-width: 150px; max-width: 150px">Trạng thái CSĐK</th>
          <th rowspan="2" style="min-width: 300px; max-width: 300px">Lịch sử chăm sóc</th>
        </tr>
        <tr>
          <th style="min-width: 170px; max-width: 170px; text-align: center">
            Nghỉ không phép
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  v-on="on"
                  v-bind="attrs"
                  style="font-size: 20px; margin-left: 6px">
                  mdi-information-outline
                </v-icon>
              </template>
              <div>Vi phạm của học sinh được tính trong tối đa 8 buổi học gần nhất</div>
            </v-tooltip>
          </th>
          <th style="min-width: 170px; max-width: 170px; text-align: center">
            Đi muộn về sớm
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  v-on="on"
                  v-bind="attrs"
                  style="font-size: 20px; margin-left: 6px">
                  mdi-information-outline
                </v-icon>
              </template>
              <div>Vi phạm của học sinh được tính trong tối đa 8 buổi học gần nhất</div>
            </v-tooltip>
          </th>
          <th style="min-width: 180px; max-width: 180px; text-align: center">
            Không làm bài tập
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  v-on="on"
                  v-bind="attrs"
                  style="font-size: 20px; margin-left: 6px">
                  mdi-information-outline
                </v-icon>
              </template>
              <div>Vi phạm của học sinh được tính trong tối đa 8 buổi học gần nhất</div>
            </v-tooltip>
          </th>
          <th style="min-width: 250px; max-width: 250px; text-align: center">
            Kiểm tra (unit test/final test)
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  v-on="on"
                  v-bind="attrs"
                  style="font-size: 20px; margin-left: 6px">
                  mdi-information-outline
                </v-icon>
              </template>
              <div>Điểm kiểm tra dưới 5/ giảm 2 điểm so với bài kiểm tra gần nhất</div>
            </v-tooltip>
          </th>
        </tr>
      </thead>
      <tbody v-if="dataPeriodicallyCareTable && dataPeriodicallyCareTable.data && dataPeriodicallyCareTable.data.length">
        <tr
          v-for="(item, index) in dataPeriodicallyCareTable.data"
          :class="`${checkDateIsBefore(item.special_care_timein) ? 'warning-student' : ''}`"
          :key="`specical-care-${index}`">
          <td class="sroll-left" style="left: 0px">
            <div v-if="item.contact_code" class="d-flex align-center">
              <img src="../../../blended/assets/star-icon.svg" class="mr-2" height="16" width="16" alt="" :style="`visibility: ${item.is_new_call? 'visible': 'hidden'}`">
              <span>{{item.contact_code}}</span>
              <div @click.stop="">
                <v-tooltip right>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      size="small"
                      rounder
                      icon
                      v-on="on"
                      @click="copyContactId(item)"
                    >
                      <v-icon>mdi-content-copy</v-icon>
                    </v-btn>
                  </template>
                  <span>Copy</span>
                </v-tooltip>
              </div>
            </div>
            <span v-else>--</span>
          </td>
          <td class="sroll-left" style="left: 170px">
            <div class="d-flex align-center justify-space-between">
              <div
                @click="handleRedirectSpecialCare(item)"
                class="ml-2 mr-3" style="font-weight: bold; cursor: pointer">{{item.full_name}}</div>
                <div class="d-flex">
                  <!-- <div
                    style="cursor: pointer"
                    @click.stop="handleExecuteCall(item, item.mobile)"
                  >
                    <img src="../../assets/phone-icon.svg" height="20" width="20" alt="">
                  </div> -->
                  <v-menu offset-y v-if="item.phoneRelated && item.phoneRelated.length">
                    <template v-slot:activator="{ on: menu, attrs }">
                        <div
                          class="d-flex flex-column align-center"
                          v-bind="attrs"
                          v-on="menu"
                        >
                          <img src="../../assets/phone-icon.svg" height="20" width="20" alt="">
                        </div>
                    </template>
                    <v-list>
                      <v-list-item
                        @click="handleExecuteCall(item, item.mobile)"
                        class="main-mobile"
                      >
                        <v-list-item-title>{{item.mobile}}</v-list-item-title>
                      </v-list-item>
                      <v-list-item
                        v-for="(phone, index) in item.phoneRelated"
                        :key="index"
                        @click="clickExecuteCallphoneRelated(item, phone)"
                        class="sub-mobile"
                      >
                        <v-list-item-title>{{formatNormalStylePhone(phone)}}</v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                  <div
                    v-else
                    style="cursor: pointer"
                    @click.stop="handleExecuteCall(item, item.mobile)"
                  >
                    <img src="../../assets/phone-icon.svg" height="20" width="20" alt="">
                  </div>
                  <v-tooltip top>
                    <template v-slot:activator="{ on,attrs }">
                      <div
                        v-if="$route.query.typeCurriculum === 'online' && (checkAuthorization('create-task-tutor_create') || checkAuthorization('create-task-tutor-secondary_create'))"
                        v-on="on"
                        v-bind="attrs"
                      >
                        <img src="../../assets/createtask.svg" style="cursor: pointer" class="ml-4" alt="" srcset=""  @click="createTask(item)">
                      </div>
                    </template>
                    <div>Tạo công việc</div>
                  </v-tooltip>
                </div>
            </div>
          </td>
          <td class="sroll-left" style="left: 420px">
            <span v-if="mapProgramIdAndProgram[item.curriculum_id]">{{ mapProgramIdAndProgram[item.curriculum_id].title }}</span>
          </td>
          <td class="text-center">{{formatDateSlash(item.special_care_timein)}}</td>
          <td v-if="$route.query.tutorSchoolLevel !== SCHOOL_LEVEL.PRIMARY" class="text-center" style="color: #BB0000">
            <div class="d-flex justify-center" style="position: relative" v-if="item.special_care_timein">
              {{getCompulsoryCareDate(item.special_care_timein)}}
              <v-tooltip top v-if="checkDateIsBefore(item.special_care_timein)">
                <template v-slot:activator="{ on, attrs }">
                  <div v-bind="attrs" v-on="on" style="position: absolute; right: -8px" class="ml-2">
                    <img src="../../assets/danger-icon.svg" height="14" width="14" alt="">
                  </div>
                </template>
                <div>Quá hạn bắt buộc</div>
              </v-tooltip>
            </div>
          </td>
          <td>
            <div v-if="item.no_adtention && item.no_adtention.details" class="d-flex justify-space-between">
              <div>
                <div>{{item.no_adtention.details.length}} buổi</div>
                <div v-if="item.no_adtention.lienTiep">Liên tiếp: {{item.no_adtention.lienTiep}} buổi</div>
              </div>
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    v-on="on"
                    v-bind="attrs"
                    style="font-size: 20px; margin-left: 12px">
                    mdi-information-outline
                  </v-icon>
                </template>
                <div>
                  <div v-for="(item, index) in item.no_adtention.details" :key="'no_adtention'+ index" class="d-flex align-center justify-end">
                    <div v-show="item.isLienTiep" class="continuous-dot mr-2"></div> {{index + 1}}. {{item.text}}
                  </div>
                </div>
              </v-tooltip>
            </div>
          </td>
          <td>
            <div v-if="item.late && item.late.details" class="d-flex justify-space-between">
              <div>
                <div v-if="item.late.lessons">{{item.late.lessons }} buổi</div>
                <div v-if="item.late.lienTiep">Liên tiếp: {{item.late.lienTiep}} buổi</div>
              </div>
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    v-on="on"
                    v-bind="attrs"
                    style="font-size: 20px; margin-left: 12px">
                    mdi-information-outline
                  </v-icon>
                </template>
                <div>
                  <div v-for="(item, index) in item.late.details" :key="'late'+ index">
                    <div class="d-flex align-center justify-start">
                      <div v-show="item.isLienTiep" class="continuous-dot mr-2"></div> {{index + 1}}. {{item.text}}
                    </div>
                  </div>
                </div>
              </v-tooltip>
            </div>
          </td>
          <td>
            <div v-if="item.no_homework && item.no_homework.details" class="d-flex justify-space-between">
              <div>
                <div>{{item.no_homework.details.length}} bài</div>
                <div v-if="item.no_homework.lienTiep">Liên tiếp: {{item.no_homework.lienTiep}} bài</div>
              </div>
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    v-on="on"
                    v-bind="attrs"
                    style="font-size: 20px; margin-left: 12px">
                    mdi-information-outline
                  </v-icon>
                </template>
                <div>
                  <div v-for="(item, index) in item.no_homework.details" :key="'no_homework'+ index" class="d-flex align-center justify-end">
                    <div v-show="item.isLienTiep" class="continuous-dot mr-2"></div> {{index + 1}}. {{item.text}}
                  </div>
                </div>
              </v-tooltip>
            </div>
          </td>
          <td>
            <div v-if="item.test && item.test.length > 0">
              <div v-for="(test, index) in item.test" :key="'test' + index" class="d-flex align-center">
                {{formatDateSlash(test.date_test)}}: {{test.score}} điểm
                <div v-if="test.comparePointAveragePoint" class="ml-2 d-flex align-center" style="font-size: 12px">
                  <div v-if="test.compareAveragePoint === 'decrease'" class="d-flex align-center mr-1">
                    <img src="../../assets/arrow-down.svg" height="12" width="12" alt="">
                  </div>
                  <div v-else-if="test.compareAveragePoint === 'increase'" class="d-flex align-center mr-1">
                    <img src="../../assets/arrow-up.svg" height="12" width="12" alt="">
                  </div>
                  <div :style="`color: ${test.compareAveragePoint === 'decrease' ? 'red' : 'green'}`">
                    {{Math.round(+test.comparePointAveragePoint)}}
                  </div>
                </div>
                <img v-if="test.link" @click="handleOpenLink(test.link)" src="../../../student_detail_bt/assets/detail-highlight-icon.svg" style="height: 14px; width: 14px; cursor: pointer; margin-left: 8px" alt="">
              </div>
            </div>
          </td>
          <td>
            <div v-if="item.cancel_lesson && item.cancel_lesson.data.length > 0" class="d-flex align-center">
              {{item.cancel_lesson.lessons}} buổi
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs}">
                  <div>
                    <img v-if="item.cancel_lesson.isRevertCancel" class="ml-3" v-on="on" v-bind="attrs" src="../../assets/danger-icon.svg" alt="">
                    <v-icon v-else v-on="on" v-bind="attrs" class="ml-3">
                      mdi-information-outline
                    </v-icon>
                  </div>
                </template>
                <div>
                  <div v-for="(lesson, index) in item.cancel_lesson.data" :key="'cancel_lesson' + index">
                    {{index +1}}. {{lesson.text}}
                    <img v-if="lesson.isRevertCancel" src="../../assets/danger-icon.svg" alt="" class="ml-1">
                  </div>
                </div>
              </v-tooltip>
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <img @click="handleShowQuickView(item, item.cancel_lesson.logIds)" v-on="on" v-bind="attrs" src="../../../student_detail_bt/assets/detail-highlight-icon.svg" alt="" class="ml-2" style="cursor: pointer">
                </template>
                <div>Xem chi tiết</div>
              </v-tooltip>
            </div>
          </td>
          <td class="text-center">
            <div v-if="item.change_teacher && item.change_teacher.data.length > 0" class="d-flex align-center">
              {{item.change_teacher.data.length}} buổi
              <v-tooltip top class="ml-1">
                <template v-slot:activator="{ on, attrs }">
                  <div>
                    <img v-if="item.change_teacher.isDelete" v-on="on" v-bind="attrs" class="ml-3" src="../../assets/danger-icon.svg" alt="">
                    <v-icon v-else v-on="on" v-bind="attrs" style="font-size: 20px" class="ml-3">
                      mdi-information-outline
                    </v-icon>
                  </div>
                </template>
                <div>
                  <div v-for="(lesson, index) in item.change_teacher.data" :key="'change_teacher' + index">
                    {{index +1}}. {{lesson.text}}
                    <img v-if="lesson.isDelete" src="../../assets/danger-icon.svg" alt="" class="ml-1">
                  </div>
                </div>
              </v-tooltip>
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <img @click="handleShowQuickView(item, item.change_teacher.logIds)" v-bind="attrs" v-on="on" src="../../../student_detail_bt/assets/detail-highlight-icon.svg" class="ml-3" style="height: 14px; width: 14px; cursor: pointer" alt="">
                </template>
                <div>Mở xem chi tiết</div>
              </v-tooltip>
            </div>
          </td>
          <td>{{formatDateSlash(item.date_next_test)}}</td>
          <td>
            <span v-if="item.homeroom_teacher_name">{{ item.homeroom_teacher_name }}</span>
            <span v-else>--</span>
          </td>
          <td
            :style="`color: ${mapCallStatus && mapCallStatus[item.call_status_id] ? mapCallStatus[item.call_status_id].color : ''}`">
            {{
              mapCallStatus && mapCallStatus[item.call_status_id] ? `${mapCallStatus[item.call_status_id].callType}-${mapCallStatus[item.call_status_id].callStatus}` : ''
            }}
          </td>
          <td>
            <div style="display: flex" v-if="item.routine_history_json">
              <div
                class="list-status-history"
                :style="generateCss(mapCallStatus && mapCallStatus[status.call_status_id] ? mapCallStatus[status.call_status_id].color : '')"
                v-for="status in item.routine_history_json.slice(-5).reverse()"
                :key="status.id">
                <span class="m-auto">
                  {{
                    mapCallStatus && mapCallStatus[status.call_status_id] ? mapCallStatus[status.call_status_id].callType : ''
                  }}
                </span>
              </div>
            </div>
          </td>
        </tr>
      </tbody>
      <tbody v-else-if="dataPeriodicallyCareTable && dataPeriodicallyCareTable.otherData && dataPeriodicallyCareTable.otherData.length > 0">
      <tr v-for="(item, index) in dataPeriodicallyCareTable.otherData" :key="'otherdata' + index">
        <td colspan="99">
          {{item.text}}
        </td>
      </tr>
      </tbody>
      <tbody v-else>
        <tr><td colspan="12" class="text-center" style="color:red">Không có kết quả phù hợp</td></tr>
      </tbody>
    </v-simple-table>
  </div>
</template>

<script>
import { SCHOOL_LEVEL } from '@/helpers/constant';
import TokenService from '@/helpers/token';
import { mapActions, mapGetters, mapState } from 'vuex';
import moment from 'moment';
import StudentCareServices from '@/services/StudentCareServices';
import BlendedCareRepository from '@/services/BlendedCareRepository';

export default {
  name: 'SpecialCareStudentTable',
  data() {
    return {
      SCHOOL_LEVEL,
      specialCareStudent: [],
    };
  },
  computed: {
    ...mapGetters(['getDevice']),
    ...mapGetters('contact_status', ['mapCallStatus']),
    ...mapGetters('student_care', ['mapProgramIdAndProgram']),
    ...mapState('student_care', ['dataPeriodicallyCareTable', 'courseExtensionShowField']),
    tableHeight() {
      const SUB_HEIGHT = 280;
      return this.getDevice.height - SUB_HEIGHT;
    },
  },
  methods: {
    ...mapActions('student_care', ['getCourseExtensionShowField']),
    async markAsReadUser(item) {
      const response = await BlendedCareRepository.markStudentAsRead({
        id: item.id,
      });
      return response;
    },
    async handleRedirectSpecialCare(item) {
      if (item.is_new_call) {
        const response = await this.markAsReadUser(item);
        if (response.message === 'Success') {
          // eslint-disable-next-line no-param-reassign
          item.is_new_call = 0;
        }
      }
      const routeData = this.$router.resolve({
        name: 'StudentDetailTutor',
        params: { id: item.id },
        query: { typeCurriculum: this.$route.query.typeCurriculum, tutorSchoolLevel: this.$route.query.tutorSchoolLevel, taskType: 1 },
      });
      if (this.$route.query.tutorSchoolLevel === SCHOOL_LEVEL.SECONDARY) {
        if (this.checkAuthorization('tutor-student-detail-secondary_read')) {
          window.open(routeData.href, '_blank');
        } else {
          this.$swal({
            title: 'Lỗi!',
            text: 'Bạn không có quyền xem thông tin học viên',
          });
        }
      } else {
        const showModal = this.checkAuthorization('tutor-student-detail_read');
        if (showModal) {
          window.open(routeData.href, '_blank');
        } else {
          this.$swal({
            title: 'Lỗi!',
            text: 'Bạn không có quyền xem thông tin học viên',
          });
        }
      }
    },
    handleShowQuickView(item, logFilter) {
      const routeData = this.$router.resolve({
        name: 'StudentDetailTutor',
        params: { id: item.id },
        query: {
          typeCurriculum: this.$route.query.typeCurriculum, tutorSchoolLevel: this.$route.query.tutorSchoolLevel, taskType: 1, logFilter,
        },
      });
      if (this.$route.query.tutorSchoolLevel === SCHOOL_LEVEL.SECONDARY) {
        if (this.checkAuthorization('tutor-student-detail-secondary_read')) {
          window.open(routeData.href, '_blank');
        } else {
          this.$swal({
            title: 'Lỗi!',
            text: 'Bạn không có quyền xem thông tin học viên',
          });
        }
      } else {
        const showModal = this.checkAuthorization('tutor-student-detail_read');
        if (showModal) {
          window.open(routeData.href, '_blank');
        } else {
          this.$swal({
            title: 'Lỗi!',
            text: 'Bạn không có quyền xem thông tin học viên',
          });
        }
      }
    },
    handleOpenLink(link) {
      window.open(link, '_blank');
    },
    checkDateIsBefore(date) {
      return moment(date).add(3, 'd').isBefore();
    },
    getCompulsoryCareDate(date) {
      return moment(date).add(3, 'd').format('DD/MM/YYYY');
    },
    copyContactId(item) {
      navigator.clipboard.writeText(item.contact_code ? item.contact_code : item.contact_id).then(
        () => {
          this.$swal({
            type: 'success',
            icon: 'success',
            showConfirmButton: false,
            toast: true,
            timer: 1000,
            title: 'Sao chép thành công!',
            position: 'top',
          });
        },
      );
    },
    generateCss(hex) {
      if (!hex) return '';
      const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex.substring(0, 7));
      return result ? `background: rgba(${parseInt(result[1], 16)}, ${parseInt(result[2], 16)}, ${parseInt(result[3], 16)}, 0.15); border: 1px solid ${hex}; color: ${hex};width:fit-content;padding:0px 4px;display:flex` : '';
    },
    async handleExecuteCall(dataContact) {
      const phoneRes = await StudentCareServices.getMobile(dataContact.id);
      const phoneCall = phoneRes && phoneRes.success ? phoneRes.data : null;
      const user = TokenService.getUser();
      if (user.ext) {
        const data = {
          mobile: phoneCall,
          showCreateAppointment: false,
          contactId: dataContact.contact_id,
          callcenter_id: user.callCenterId,
          mainId: dataContact.mainId,
          mainMobile: phoneCall,
          store: 'T',
          contactCode: dataContact.contact_code,
          homeroomTeacherId: dataContact.homeroom_teacher_id,
          studentProductId: dataContact.student_product_id,
          callStatusId: dataContact.call_status_id,
          callId: dataContact.call_id,
        };
        Bus.$emit('voice-call-show-popup', data);
        if (dataContact.is_new_call) {
          const response = await this.markAsReadUser(dataContact);
          if (response.message === 'Success') {
            // eslint-disable-next-line no-param-reassign
            dataContact.is_new_call = 0;
          }
        }
      } else {
        this.$swal({
          title: 'Lỗi!',
          text: 'Chưa có máy lẻ. Vui lòng liên hệ Admin.',
        });
      }
    },
    async clickExecuteCallphoneRelated(dataContact, phone) {
      const phoneRes = await StudentCareServices.getMobile(dataContact.id);
      const phoneCall = phoneRes && phoneRes.success ? phoneRes.data : null;
      const user = TokenService.getUser();
      if (user.ext) {
        const data = {
          mobile: phone,
          showCreateAppointment: false,
          contactId: dataContact.contact_id,
          callcenter_id: user.callCenterId,
          mainId: dataContact.mainId,
          mainMobile: phoneCall,
          store: 'T',
          contactCode: dataContact.contact_code,
          homeroomTeacherId: dataContact.homeroom_teacher_id,
          studentProductId: dataContact.student_product_id,
          callStatusId: dataContact.call_status_id,
          callId: dataContact.call_id,
        };
        Bus.$emit('voice-call-show-popup', data);
      } else {
        this.$swal({
          title: 'Lỗi!',
          text: 'Chưa có máy lẻ. Vui lòng liên hệ Admin.',
        });
      }
    },
    createTask(item) {
      Bus.$emit('openModalTriggerTask', null, item);
    },
  },
  async created() {
    const loading = this.$loading.show();
    if (!this.courseExtensionShowField) {
      await this.getCourseExtensionShowField();
    }
    loading.hide();
  },
};
</script>

<style lang="scss">
.continuous-dot {
  background: #EB5757;
  border-radius: 50%;
  height: 6px;
  width: 6px;
}
.special-care-student-table .list-status-history {
  margin-right: 5px;
  width: 39px;
  height: 25px;
  border-radius: 4px;
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: 13px;
  text-align: center;
  padding-top: 5px;
}
.special-care-student-table{
  margin-top: 20px;
  thead {
    tr{
      .sroll-left {
        z-index: 3 !important;
      }
      th {
        &:nth-last-child(1 of .sroll-left){
          border-right: 1px solid #d2d2d2;
        }
        font-size: 13px !important;
        background: #F4F2F2 !important;
      }
      .merge-header{
        &:nth-last-child(1 of .merge-header) {
          border-right: 2px solid white;
        }
        border-left: 2px solid white;
      }
      &:last-child{
        th {
          &:last-child {
            border-right: 2px solid white;
          }
          border-left: 2px solid white;
        }
      }
    }
  }
  tbody {
    tr {
      &.warning-student {
        td {
          background: #FFEAEA;
        }
      }
      &:hover {
        td {
          background: #F4F2F2;
        }
      }
      td {
        &:nth-child(3) {
          border-right: 1px solid #d2d2d2;
        }
      }
      .sroll-left {
        position: sticky;
        background: #fff;
        z-index: 1;
      }
    }
  }
}
</style>
